import { useState } from 'react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/Button';
import { useTabs } from '@/features/tabs';
import { logError } from '@/lib/errorLogging';

import { type MeetingDebugCard } from '../meeting-debug.cards';
import { startMeetingDebugChat } from '../meeting-debug.chat';

export function MeetingDebugChatButton({
  card,
  title,
}: {
  card: MeetingDebugCard;
  title: string;
}) {
  const { openTab } = useTabs();
  const [isStarting, setIsStarting] = useState(false);

  const startChat = async () => {
    setIsStarting(true);
    try {
      const chatId = await startMeetingDebugChat(card, title);
      if (chatId) openTab({ path: `/chats/${chatId}` });
    } catch (error) {
      logError(error, 'Failed to start a meeting debug chat');
      toast.error('Could not start the debug chat. Try again.');
    } finally {
      setIsStarting(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      disabled={isStarting}
      onClick={() => void startChat()}
    >
      Debug in chat
    </Button>
  );
}
